module.exports = __webpack_public_path__ + "static/img/b1-4-1.65342b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/b1-4-1.png
// module id = /r2t
// module chunks = 1